var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-logo-wrapper",on:{"click":_vm.openPage}},[(_vm.conf.newToolLogo)?_c('div',{staticClass:"app-logo custom",style:({
      content: ("url(" + (_vm.$handleAssetsUrl(_vm.conf.newToolLogo)) + ")")
    })}):(_vm.ready)?_c('div',{staticClass:"app-logo official"}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5ddf82a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/topnav/appLogo.vue
// module id = null
// module chunks = 